import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Main from "./components/Main"; // Z main
import Blog from "./components/Blog";
import PostPage from "./components/BlogComponents/PostPage";
import AktualnosciManager from "./components/Dashboard/AktualnosciManager";
import PartnersManager from "./components/Dashboard/PartnersManager";
import Welcome from "./components/Welcome";
//login
import Dashboard from './components/Dashboard/Dashboard';
import Preferences from './components/Preferences/Preferences';
//router
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import useToken from './components/App/useToken';
import { trackPageView } from './analytics';

// Wysyła zdarzenie page_view do Google Analytics przy każdej zmianie
// podstrony (SPA nie przeładowuje strony, więc GA samo tego nie wykryje).
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const { token, setToken } = useToken();

  const loginHandler = () => {
    setToken("");
    localStorage.removeItem('token');
  }

  const handleWindowSizeChange = () => {
    if (window.innerWidth <= 1000) { setIsMobile(true); }
    else { setIsMobile(false); }
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <RouteTracker />
        <Header loginHandler={loginHandler} isLoggedin={token} />
        <Welcome />
        {/*router*/}
        <div className="wrapper">
          <Routes>
            <Route exact path="/dashboard" element={<Dashboard isLoggedin={token} setIsLoggedin={setToken} loginHandler={loginHandler} />} />
            <Route exact path="/dashboard/aktualnosci" element={<AktualnosciManager isLoggedin={token} setIsLoggedin={setToken} />} />
            <Route exact path="/dashboard/partnerzy" element={<PartnersManager isLoggedin={token} setIsLoggedin={setToken} />} />
            <Route exact path="/preferences" element={<Preferences />} />
            <Route exact path="/aktualnosci" element={<Blog />} />
            <Route exact path="/aktualnosci/:postId" element={<PostPage />} />
            <Route index element={<Main isMobile={isMobile} />} />
          </Routes>
        </div>
        {/*end router*/}
        <Footer />
      </div>
    </BrowserRouter>
  );
}
export default App;
